import type { QueryClient } from "@tanstack/react-query";
import { createRootRouteWithContext, Outlet } from "@tanstack/react-router";
import ErrorBoundaryProvider from "../providers/error/ErrorBoundaryProvider.tsx";
import SzBackdrop from "../ui/components/UISharedConstructors/Loading/SzBackDrop.tsx";

interface IMMRouterContext {
	/**
	 * query client from tanstack o be used in routes and app
	 */
	queryClient: QueryClient;
}

/**
 * The root route of the app that serves as the main Layout wrapper for the app
 * within the ```<Outlet />``` are rendered individual routes
 */
export const Route = createRootRouteWithContext<IMMRouterContext>()({
	component: Outlet,
	pendingComponent: () => <SzBackdrop message="ještě chvilku" />,
	errorComponent: ({ error, reset }) => {
		return <ErrorBoundaryProvider error={error} reset={reset} />;
	},
});
